/** Toggle Bootstrap RTL stylesheet + html dir/lang without full page reload */

const LINK_ID = 'app-bootstrap-rtl'

function rtlStylesheetHref() {
  const base =
    typeof process !== 'undefined' && process.env && process.env.BASE_URL
      ? process.env.BASE_URL
      : '/'
  const normalized = String(base).replace(/\/?$/, '/')
  return `${normalized}bootstrap-rtl.min.css`
}

/**
 * @param {'ar' | 'en'} lang
 */
export function applyDocumentLang(lang) {
  const isAr = lang === 'ar'
  const html = document.documentElement
  html.setAttribute('dir', isAr ? 'rtl' : 'ltr')
  html.setAttribute('lang', isAr ? 'ar' : 'en')

  let link = document.getElementById(LINK_ID)
  if (!link) {
    link = document.createElement('link')
    link.id = LINK_ID
    link.rel = 'stylesheet'
    link.href = rtlStylesheetHref()
    document.head.appendChild(link)
  }

  if (isAr) {
    link.removeAttribute('disabled')
  } else {
    link.setAttribute('disabled', 'disabled')
  }
}
